<template>
	<v-dialog
			:value="isViewVersion"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View version</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<div class="item">
						<field
								:class-error="getError('version')"
								margin="0"
								width="100%"
								label="Version"
								:placeholder="getLastVersionText()"
								:setInputValue="version"
								@updateInput="onInput($event, 'version')"
								is-required
						></field>
					</div>
					<div class="item">
						<field
								margin="0"
								type="text"
								label="🗓️ Changelog publication date"
								placeholder="MM/DD/YYYY HH:MM"
								:dateValue="date"
								display-format="YYYY-MM-DD hh:mm"
								@updateTime="onTime($event, 'date')"
								is-time
								is-required
						></field>
					</div>

				</div>
				<div class="main">

					<div class="item descriptionWrapper">
						<div class="label">📝 Changelog description</div>
						<div class="description">
							<vue-editor
									ref="editor"
									v-model="msg"
									placeholder="Enter description"
									:key="msgKey"
							/>
						</div>
					</div>
				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';

Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewVersion",
	components: {
		Preload,
		VueEditor,
	},
	computed: {
		...mapGetters([
			'settingVersionsEdit',
		]),
	},
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
		lastVersion: Object,
	},
	validations: {
		version: { required },
		date: { required }, // Добавьте валидацию для обязательного поля
	},
	data: () => ({
		isViewVersion: true,
		isPreloader: false,
		content: null,
		id: null,
		version: null,
		msgKey: 0,
		msg: '',
		date: null,
	}),

	methods: {
		...mapActions([
			'setAlert',
			'onSettingVersionsSave',
			'onSettingVersionsEdit',
		]),
		getLastVersionText() {
			return `Last version: ${ this.lastVersion.version }`;
		},

		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { id, date, version } = this.$data;

				// Отримуємо HTML-контент із редактора напряму
				const msg = this.$refs.editor?.quill.root.innerHTML || '';

				if (this.dialogFlag === 'add') {
					await this.onSettingVersionsSave({ msg, date, version });
				} else {
					await this.onSettingVersionsEdit({ msg, id, date, version });
				}

				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}

			this.isPreloader = false;
		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	async mounted() {
		this.isPreloader = true;
		// id
		// date
		// version
		// msg
		if (this.dialogFlag === 'add') {
			this.msg = '';
			this.version = null;
			this.id = null;
		} else {
			const { date, version, id, msg } = this.settingVersionsEdit.row;

			this.date = date;
			this.version = version;
			this.id = id;

			// 👇 Вставка HTML напряму в редактор
			this.msg = ''; // очищаємо, щоб уникнути конфлікту з v-model
			this.msgKey++; // змушує редактор перерендеритися

			this.$nextTick(() => {
				const editor = this.$refs.editor?.quill;
				if (editor && msg) {
					editor.setContents(editor.clipboard.convert(msg));
				}
			});
		}

		this.isPreloader = false;
	}
};
</script>
<style>
@import "vueEditor.scss";
</style>
<style scoped lang="scss">
@import "ViewVersion";
</style>
